import { Capacitor } from "@capacitor/core";

// Extra details sent with each search so admin can see what people look for (Search Demand page).

const GUEST_ID_KEY = "cars53_guest_id";
const GUEST_PHONE_KEY = "cars53_guest_phone";

// Mobile number a guest enters to search one-way availability; reused to pre-fill login
export const getGuestPhone = () => {
    try { return localStorage.getItem(GUEST_PHONE_KEY) || ""; } catch (e) { return ""; }
};
export const saveGuestPhone = (phone) => {
    try { localStorage.setItem(GUEST_PHONE_KEY, phone); } catch (e) { /* storage unavailable */ }
};
export const isValidGuestPhone = (phone) => /^[6-9]\d{9}$/.test(String(phone || ""));

// Random id kept on this device so a guest's repeat searches can be grouped
const getGuestId = () => {
  try {
    let id = localStorage.getItem(GUEST_ID_KEY);
    if (!id) {
      id = window.crypto?.randomUUID
        ? window.crypto.randomUUID()
        : `g-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
      localStorage.setItem(GUEST_ID_KEY, id);
    }
    return id;
  } catch (e) {
    return "";
  }
};

// City of a Mapbox feature, or of a master-city pick (which carries cityId).
// District first: it matches our master city names ("Ratlam"), where place can be "Ratlam Nagar".
const cityOf = (feature) => {
  const props = feature?.properties || {};
  const ctx = props.context || {};
  if (feature?.cityId) return props.full_address || "";
  if (props.feature_type === "district") return props.name || "";
  return ctx.district?.name || ctx.place?.name || (props.feature_type === "place" ? props.name : "") || ctx.locality?.name || "";
};

const addressOf = (feature) => feature?.properties?.full_address || feature?.properties?.name || "";

export const getSearchMeta = (fromFeature, toFeature) => ({
  fromAddress: addressOf(fromFeature).slice(0, 500),
  fromCity: cityOf(fromFeature).slice(0, 120),
  toAddress: addressOf(toFeature).slice(0, 500),
  toCity: cityOf(toFeature).slice(0, 120),
  guestId: getGuestId(),
  platform: Capacitor.getPlatform(),
});
